const keyBy = require('lodash/keyBy')

/**
 * Enriches decorated routes with funder data from the funders API.
 * Should only be called for the detail (single-route) path — not the list
 * endpoint — to avoid expensive N+1 lookups.
 *
 * @param {Array} decoratedRoutes - Routes already decorated with shipment data
 * @param {Object} mainApi - The main API (needs mainApi.funders and mainApi.program)
 * @returns {Promise<Array>} Routes with funder object on each shipment
 */
async function enrichRoutesWithFunders (decoratedRoutes, mainApi) {
  const allShipments = decoratedRoutes.flatMap(r => r.shipments || [])
  const allFunderIds = new Set(allShipments.map(s => s.funder_id).filter(Boolean))
  const allProgramIds = new Set(allShipments.map(s => s.program_id).filter(Boolean))

  if (allFunderIds.size === 0) {
    return decoratedRoutes
  }

  const programIds = Array.from(allProgramIds)
  const funders = await mainApi.funders.list({ unfiltered: false, programIds })
  const fundersById = keyBy(funders, '_id')

  return decoratedRoutes.map(route => ({
    ...route,
    shipments: (route.shipments || []).map(s => ({
      ...s,
      funder: fundersById[s.funder_id] || null
    }))
  }))
}

module.exports = { enrichRoutesWithFunders }
